/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：设置相关接口
 */
import { post, get, put, deletes } from "@common/http";

/**
 * common获取设置列表 根据dict_type
 * @param param
 * @returns {*}
 */
// https://dev.meiql.com/dict?dict_type=DT_005&asc=dict_code
export const getDictList = (param) => get("/dict", param);

/**
 * common添加设置列表  根据dict_type
 * @param param
 * @returns {*}
 */
export const AddDictList = (param) => post("/dict", param);

// common修改设置  根据dict_type
export const modifyDictList = (param) => put("/dict", param);

// common批量修改设置  根据dict_type   /tenant-product/batch
export const modifyBatchDictList = (param) => put("/dict/batch", param);
export const tenantProductBatch = (param) => put("/tenant-product/batch", param);

// common删除设置  根据dict_type g/${id ? id : ''
export const DelDictList = (id, param) => deletes(`/dict/${id}`, param);

// 获取权限组设置列表
export const getRoleList = (param) => get("/role", param);

// 门店权限组权限获取
export const getRoleListWith = (param) => get("/role/list-with-post", param);

// 删除TBsRole信息
export const delRole = (id, param) => deletes(`/role/${id}`, param);

// 添加权限组设置列表
export const AddRoleList = (param) => post("/role", param);

// 获取每一个对应权限组的权限
export const getRolePerList = (param) => get("/role-permission/list", param);

// 修改权限组的权限
export const SaveRolePerList = (param) => put("/role-permission", param);

// 获取职位设置列表（这里带人数字段）
export const getTenantPost = (id, param) => get(`/tenant-post/list/with-employee-num/${id ? id : ""}`, param);

export const getTenant = (param) => get(`/tenant-post/list`, param);

// 获取职位设置列表（这里不带人数）
export const getTenantBase = (id, param) => get(`/tenant-post/${id ? id : ""}`, param);

// 修改职位设置
export const ModifyTenantPost = (param) => put("/tenant-post", param);

// 新增职位设置
export const AddTenantPost = (param) => post("/tenant-post", param);

//删除职位
export const DelTenantPost = (id, param) => deletes(`/tenant-post/${id ? id : ""}`, param);

// 交易设置
export const putTenant = (param) => put("/tenant", param);

// 提交支出表
export const putAmount = (param) => put("/tenant-disburse/batch", param);

// 获取支出表
export const gitAccount = (param) => get("/tenant-disburse/list", param);

// 总计支出表
export const gitTotal = (param) => get("/tenant-disburse/disburse", param);

// 分页查询支出
export const getSelectAccount = (param) => get("/tenant-disburse", param);

// 支出明细分页查询支出
export const getSelectData = (param) => get("/tenant-disburse/list", param);

// 新增租户支出
export const addAccount = (param) => post("/tenant-disburse", param);

// 修改租户支出
export const modifyAccount = (param) => put("/tenant-disburse", param);

// 删除租户支出
export const deleteAccount = (id) => deletes(`/tenant-disburse/${id}`);

// 批量删除支出
export const deleteAccounts = (param) => get("/tenant-disburse/deleteBatchByIds", param);

// 职位排序
export const updateSort = (param) => put("/tenant-post/batch", param);

// 查询部门列表
export const getDepartmentList = () => get("/departmentClass/listDepartment");

// 新增部门
export const addDepartment = (param) => post("/departmentClass", param);

// 修改部门
export const putDepartment = (param) => put("/departmentClass", param);

// 禁用部门
export const deleteDepartment = ({ id }) => deletes(`/departmentClass/${id}`);

// 启用部门
export const enableDepartment = ({ id }) => post(`/departmentClass/able/${id}`);

//  修改是否开启部门业绩
export const modifyDepartmentPerformance = (param) => put("/tenant", param);

// 获取分类列表
export const getCategoryList = (param) => get("/departmentClass/getClassList", param);

//
export const addSettingsPointsItem = (param) => post("/dict/add", param);



// WEBPACK FOOTER //
// ./src/api/setting.js